var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.63623,
    y: 0.636719,
    width: 64.1345,
    height: 64.1345,
    rx: 12.2798,
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenImg4);
export default __webpack_public_path__ + "static/media/brighten-img-4.9ac76c5f3ceee13ea2efe5baa4f84b80.svg";
export { ForwardRef as ReactComponent };